<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <mat-select [(value)]="value" [compareWith]="compareWith" [multiple]="multiple">
        <ng-container *ngFor="let option of Groups">
            <mat-option [value]="getOnlyId ? option.Id : option">
                {{option.Title}}
            </mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>
